import Route from '@App/routes/Route';

/** Routes */

export const PLAYLISTS = new Route('playlists', '/playlist');
export const PLAYLIST = new Route('playlist', '/playlist/{slug}-{id}', { slug: '[^/]+',  id: '[0-9]+' }, PLAYLISTS);
export const PLAYLIST_LEGACY = new Route('playlist_legacy', '/playlist/{slug}', { slug: '[^/]+' }, PLAYLISTS);
export const LIBRARY = new Route('library', '/');
export const SOUND_EFFECTS = new Route('sound_effects', '/effets-sonores');
export const ALBUMS = new Route('albums', '/album', {});
export const ALBUM = new Route('album', '/album/{reference}', { reference: '[^/]+' }, ALBUMS);

export const LABELS = new Route('labels', '/label', {});
export const LABEL = new Route('label', '/label/{reference}-{slug}', { reference: '[^/-]+', slug: '[^/]+' }, LABELS);
export const PROJECTS = new Route('projects', '/mes-projets');
export const PROJECT = new Route('project', '/mes-projets/{id}', { id: '[^/]+' }, PROJECTS);

export const LICENCE_REQUESTS = new Route('licence_requests', '/mes-demandes-d-autorisation');
export const LICENCE_REQUEST_NEW = new Route('licence_request_new', '/mes-demandes-d-autorisation/nouvelle-demande', {}, LICENCE_REQUESTS);
export const LICENCE_REQUEST = new Route('licence_request', '/mes-demandes-d-autorisation/{id}', { id: '[^/]+' }, LICENCE_REQUESTS);

export const PROFILE = new Route('profile', '/mon-compte');
export const LEGAL_NOTICES = new Route('legal_notices', '/mentions-legales');
export const CART = new Route('cart', '/panier');
export const ORDERS = new Route('orders', '/mes-commandes');
export const ORDER = new Route('order', '/mes-commandes/{id}', { id: '[^/]+' }, ORDERS);

export const SUBSCRIPTION = new Route('subscription', '/abonnement');

export const HUBSPOT_PAGES = {
    HOME: '',
    OFFERS: 'offres',
    SERVICES: 'services',
    CGU: 'conditions-generales-utilisation',
    CGL: 'conditions-generales-licence',
    RATES: 'tarifs',
    CONTACT: 'nous-contacter',
    MUSIC_SEARCH: 'recherche-musicale',
    FAQ: 'support',
    // Quote request for a licence on a given project (from the cart).
    DEVIS: 'offres/demande-devis',
    // Quote request for the enterprise subscription, which has its own landing page — distinct from
    // DEVIS above, the per-project licence quote the cart links to.
    //
    // ⚠️ This address answers 404 today: the client asked for this exact URL and is creating the page
    // on their side. It is not a typo, and `/start/devis` — which does exist — is not the page to
    // fall back on: that one is reached from the cart for a licence on a given project, and it
    // answers a different question than an enterprise subscription. Leave it as is until the page
    // is published.
    DEVIS_ENTREPRISE: '/start/devis-entreprise',
    // Sales demo booking, offered next to the subscription call to action.
    DEMO: '/start/reservez-une-demonstration',
};

/** Back-end routes (virtual) */

export const LOGIN = new Route('login', '/login');
export const LOGOUT = new Route('logout', '/logout');
export const REGISTER = new Route('register', '/creation-de-compte');
export const CREATE_PLAYLIST_FROM_PROJECT = new Route('admin_playlist_create', '/admin/v2/playlist/create?project={project}', { project: '[^/]+' });
export const DUPLICATE_PROJECT = new Route('admin_project_duplicate', '/admin/project/{project}/duplicate', { project: '[^/]+' });

/**
 * Routes as array
 *
 * @type {Array}
 */
const routes = [
    ALBUMS,
    ALBUM,
    CART,
    PLAYLISTS,
    PLAYLIST,
    PLAYLIST_LEGACY,
    LIBRARY,
    SOUND_EFFECTS,
    PROJECTS,
    PROJECT,
    LABELS,
    LABEL,
    LICENCE_REQUESTS,
    LICENCE_REQUEST_NEW,
    LICENCE_REQUEST,
    LEGAL_NOTICES,
    LOGIN,
    ORDER,
    ORDERS,
    PROFILE,
    REGISTER,
    SUBSCRIPTION,
];

/**
 * Find route by url
 *
 * @param  {String} url
 *
 * @return {Route}
 */
export function findByUrl(url) {
    return routes.find(route => route.match(url));
}

/**
 * Find route by name
 *
 * @param  {String} name
 *
 * @return {Route|null}
 */
export function findByName(name) {
    return routes.find(route => route.name === name) || null;
}

/** Export routes as array */
export default routes;

export function redirectToLogin() {
    window.location = LOGIN.getUrl();
}

export function redirectToSubscriptionForm() {
    window.location = SUBSCRIPTION.getUrl();
}

export function redirectToProfileSubscription() {
    window.location = PROFILE.getUrl() + '#abonnement';
}
